export default function AboutMeImg () {
  return (
    <section className='flex justify-center'>
      <img
        src={process.env.PUBLIC_URL + 'images/aboutMe_img.png'} alt='picture_of_me' className='
        w-[600px] h-[700px]
        rounded-md mr-0
        md:w-[200px]
        md:h-[300px]
        min-[300px]:w-[200px] max-[650px]:h-[300px]
        min-[300px]:pb-[20px]'
      />
    </section>
  )
}
